/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkActionLead } from './InstanceBulkActionLead';
import {
    InstanceBulkActionLeadFromJSON,
    InstanceBulkActionLeadFromJSONTyped,
    InstanceBulkActionLeadToJSON,
} from './InstanceBulkActionLead';

/**
 * 
 * @export
 * @interface InstanceBulkActionExcludedInstance
 */
export interface InstanceBulkActionExcludedInstance {
    /**
     * 
     * @type {InstanceBulkActionLead}
     * @memberof InstanceBulkActionExcludedInstance
     */
    lead: InstanceBulkActionLead;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionExcludedInstance
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionExcludedInstance
     */
    reason_code: InstanceBulkActionExcludedInstanceReasonCodeEnum;
}


/**
 * @export
 */
export const InstanceBulkActionExcludedInstanceReasonCodeEnum = {
    FinalDecision: 'final_decision',
    AlreadyDeclined: 'already_declined',
    HasAdmissionStatus: 'has_admission_status',
    DifferentSource: 'different_source',
    IntegrationDisabled: 'integration_disabled'
} as const;
export type InstanceBulkActionExcludedInstanceReasonCodeEnum = typeof InstanceBulkActionExcludedInstanceReasonCodeEnum[keyof typeof InstanceBulkActionExcludedInstanceReasonCodeEnum];


/**
 * Check if a given object implements the InstanceBulkActionExcludedInstance interface.
 */
export function instanceOfInstanceBulkActionExcludedInstance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "reason_code" in value;

    return isInstance;
}

export function InstanceBulkActionExcludedInstanceFromJSON(json: any): InstanceBulkActionExcludedInstance {
    return InstanceBulkActionExcludedInstanceFromJSONTyped(json, false);
}

export function InstanceBulkActionExcludedInstanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionExcludedInstance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead': InstanceBulkActionLeadFromJSON(json['lead']),
        'reason': json['reason'],
        'reason_code': json['reason_code'],
    };
}

export function InstanceBulkActionExcludedInstanceToJSON(value?: InstanceBulkActionExcludedInstance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead': InstanceBulkActionLeadToJSON(value.lead),
        'reason': value.reason,
        'reason_code': value.reason_code,
    };
}

